/* src/app/hire-person-search/hiring-criteria/hiring-criteria.component.scss */
.hire-btn-primary {
  background-color: #2E93A1;
  color: #fff;
  outline: none;
  border: none;
  padding: 6px 16px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  border: 1px solid #2E93A1;
}
.hire-btn-success {
  background-color: #28a745;
  color: #fff;
  outline: none;
  border: none;
  padding: 6px 16px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  border: 1px solid #28a745;
}
.hire-btn-danger {
  background-color: #dc3545;
  color: #fff;
  outline: none;
  border: none;
  padding: 6px 16px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  border: 1px solid #dc3545;
}
.hire-btn-warning {
  background-color: #ffc107;
  color: #fff;
  outline: none;
  border: none;
  padding: 6px 16px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  border: 1px solid #ffc107;
}
.hire-btn-secondary {
  background-color: #ffffff;
  color: #fff;
  outline: none;
  border: none;
  padding: 6px 16px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  border: 1px solid #D5DEE6;
  color: #2E93A1;
}
.filter-layout {
  background: #fff;
  overflow: hidden;
  position: relative;
}
.fl-header {
  width: 100%;
  height: auto;
  background-color: #F2F2F2;
  display: flex;
  align-items: center;
  padding: 16px 20px;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 1;
}
.fl-container {
  display: flex;
  width: 100%;
}
.fl-container .side-panel {
  width: 32%;
  display: flex;
  padding: 12px 12px;
  align-items: flex-start;
  gap: 6px;
  align-self: stretch;
  border-right: 1px solid #EEF2F5;
}
.fl-container .side-panel .tab-list {
  list-style: none;
  margin: 0;
  padding: 0 0px;
  flex: 1;
  overflow-y: auto;
}
.fl-container .side-panel .tab-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 12px;
  margin-bottom: 0px;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  transition: background-color 0.18s ease, color 0.18s ease;
  color: #484b59;
  font-size: 14px;
  font-weight: 500;
  outline: none;
  -webkit-user-select: none;
  user-select: none;
}
.fl-container .side-panel .active {
  border-radius: 4px;
  background-color: #F4F9FA;
  font-weight: 500;
}
.fl-container .side-panel .active .tab-icon {
  filter: drop-shadow(0 0 6px rgba(108, 140, 255, 0.25));
}
.fl-container .side-panel .list-group {
  border: none;
  width: 100%;
}
.fl-container .side-panel .list-group .list-group-item {
  border: none;
  padding: 12px 6px;
  display: flex;
  align-items: center;
}
.fl-container .side-panel .list-group .list-group-item span {
  margin-right: 5px;
}
.fl-container .content-body {
  display: flex;
  width: 68%;
  height: calc(100vh - 100px);
  overflow-y: auto;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  scroll-behavior: smooth;
}
.fl-container .content-body::-webkit-scrollbar {
  width: 4px;
}
.fl-container .content-body::-webkit-scrollbar-track {
  background: transparent;
}
.fl-container .content-body::-webkit-scrollbar-thumb {
  background: #F2F2F2;
  border-radius: 3px;
}
.fl-container .content-body .filter-groups-section {
  width: 100%;
  margin-bottom: 24px;
}
.fl-container .content-body .filter-groups-section:last-child {
  padding-bottom: 200px;
}
.fl-container .content-body textarea.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  min-height: 100px;
}
.fl-container .content-body input.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  height: 30px;
}
.fl-container .content-body select.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 4px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  height: 30px;
}
.fl-container .content-body .label-style {
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 6px;
}
.fl-container .content-body .dropdown-caret {
  position: relative;
  width: fit-content;
}
.fl-container .content-body .dropdown-caret::after {
  content: "";
  display: flex;
  position: absolute;
  right: 3px;
  top: 5px;
  width: 12px;
  height: 12px;
  color: #484b59;
  font-size: 12px;
  transition: rotate 0.3s ease;
  background-image: url("./media/caret-down-S5OF35ZE.svg");
  background-size: contain;
  background-repeat: no-repeat;
}
.fl-container .content-body .dropdown-caret.distance-dropdown select.caret-remove {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  min-width: 80px;
}
.fl-container .content-body .dropdown-caret.distance-dropdown::after {
  right: 7px;
  top: 8px;
}
.fl-container .content-body .custom-select {
  min-width: 50px;
  width: 70px;
  padding: 4px 6px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fff;
  font-size: 12px;
  cursor: pointer;
  color: #484b59;
}
.fl-container .content-body .custom-select:focus {
  outline: none;
  border-color: #007bff;
}
.fl-container .content-body select.custom-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.fl-container .content-body select.caret-remove {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  min-width: 70px;
}
.fl-container .content-body select.caret-remove2 {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  min-width: 105px;
}
.highlight-pill {
  max-width: max-content;
  width: -moz-max-content;
  width: max-content;
  padding: 4px 8px;
  border-radius: 30px;
  align-items: center;
  font-weight: 12px;
  cursor: pointer;
  font-weight: 400;
}
.highlight-pill img {
  width: 12px;
}
.disabled-input {
  pointer-events: none;
  background-color: #eaeaea !important;
}
.save-input {
  background-color: #f8f8f8;
}
::ng-deep div.mat-mdc-autocomplete-panel {
  padding: 6px 0 !important;
}
::ng-deep div.mat-mdc-autocomplete-panel::-webkit-scrollbar {
  width: 4px;
}
::ng-deep div.mat-mdc-autocomplete-panel::-webkit-scrollbar-track {
  background: #f1f1f1 !important;
}
::ng-deep div.mat-mdc-autocomplete-panel::-webkit-scrollbar-thumb {
  background: #969696 !important;
}
::ng-deep div.mat-mdc-autocomplete-panel::-webkit-scrollbar-thumb:hover {
  background: #555 !important;
}
::ng-deep div.mat-mdc-autocomplete-panel .mat-mdc-option {
  min-height: 30px !important;
  padding: 0 12px !important;
  font-size: 12px !important;
  letter-spacing: inherit !important;
}
::ng-deep .p-multiselect-label.p-placeholder {
  font-size: 12px !important;
  color: #969696 !important;
  font-weight: normal !important;
}
::ng-deep .p-component * {
  box-sizing: border-box;
  width: auto !important;
  font-family: "Poppins", sans-serif;
  font-size: 12px !important;
  background: #ffffff;
}
::ng-deep .p-component .p-checkbox,
::ng-deep .p-component .p-checkbox {
  width: 16px !important;
  height: 16px !important;
  margin-right: 10px !important;
}
::ng-deep .p-component .p-checkbox .p-checkbox-input,
::ng-deep .p-component .p-checkbox .p-checkbox-input {
  width: 16px !important;
  height: 16px !important;
}
::ng-deep .p-component .p-checkbox .p-checkbox-input .p-checkbox-box,
::ng-deep .p-component .p-checkbox .p-checkbox-input .p-checkbox-box {
  width: 16px !important;
  height: 16px !important;
}
::ng-deep .p-component .p-checkbox .p-checkbox-box {
  width: 16px !important;
  height: 16px !important;
}
::ng-deep .p-multiselect-option {
  margin-bottom: 8px !important;
}
::ng-deep .p-multiselect-dropdown {
  position: relative;
}
::ng-deep .p-multiselect-dropdown svg {
  display: none !important;
  width: 12px !important;
  height: 12px !important;
}
::ng-deep .p-multiselect-dropdown svg path[fill~=currentColor] {
  color: #5E5E5E !important;
}
::ng-deep .p-multiselect-dropdown::after {
  content: "";
  display: block;
  position: absolute;
  right: 0;
  top: 2px;
  width: 12px;
  height: 12px;
  color: #484b59;
  font-size: 12px;
  transition: rotate 0.3s ease;
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
  background-image: url("./media/caret-down-S5OF35ZE.svg");
  background-size: contain;
  background-repeat: no-repeat;
}
::ng-deep .p-multiselect-open .p-multiselect-dropdown::after {
  transform: rotate(180deg);
  transition: rotate 0.3s ease;
}
.fl-count {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 12px;
  background-color: #2E93A1;
}
::ng-deep span.mat-mdc-option.mdc-list-item--disabled {
  cursor: default;
  pointer-events: none;
}
.no-btn-text-only {
  border: none;
  outline: none;
  background-color: transparent;
  padding: 0;
  color: #484b59;
  font-size: 12px;
}
::ng-deep ngb-tooltip-window .tooltip-inner {
  color: #ffffff;
  text-align: left;
  background-color: #484b59;
  max-width: 200px;
  width: 200px;
}
::ng-deep .mat-mdc-option.mdc-list-item--disabled {
  pointer-events: auto !important;
}
::ng-deep .mat-mdc-option.mdc-list-item--disabled .tooltip-wrapper {
  pointer-events: auto;
  cursor: not-allowed;
}
::ng-deep .mat-mdc-option.mdc-list-item--disabled .mdc-list-item__primary-text {
  pointer-events: none;
}
.ms-wrapper {
  position: relative;
}
.ms-wrapper .ms-fake-label {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  padding-left: 12px;
  background: var(--p-multiselect-background, #fff);
  pointer-events: none;
  z-index: 1;
}
:ng-deep .p-component * {
  width: 100% !important;
}
.hire-btn-primary {
  width: 90px;
}
.hire-btn-primary.disabled {
  background-color: #969696;
  border-color: #969696;
  pointer-events: none;
}
.remove-caret::after {
  display: none;
}
.hire-btn-primary.dropdown-toggle::after {
  display: none !important;
}
.criteria-body {
  width: 100%;
  padding: 20px;
}
.example-list {
  width: 100%;
  max-width: 100%;
  border: none;
  min-height: 60px;
  display: block;
  color: #484B59;
  border-radius: 4px;
  overflow: hidden;
  font-family: sans-serif;
}
.example-box {
  padding: 0px 0px;
  border-bottom: none;
  color: #484b59;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  cursor: grab;
  cursor: -moz-grab;
  font-size: 14px;
  font-family: "Poppins", sans-serif;
  margin-bottom: 16px;
}
.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.example-box:last-child {
  border: none;
}
.example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.example-custom-placeholder {
  background: #ccc;
  border: dotted 3px #999;
  min-height: 60px;
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.new-criteria-card {
  border-radius: 4px;
  background-color: #FAFAFA;
  display: flex;
  justify-content: flex-start;
  padding: 10px;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  font-family: "Poppins", sans-serif;
}
.new-criteria-card input.wc-form-control {
  border: 1px solid #fff;
  border-radius: 4px;
  background-color: #fff;
  padding: 10px;
  color: #484B59;
  font-family: "Poppins", sans-serif;
}
.new-criteria-card .label-criteria {
  width: 80px;
}
.new-criteria-card .criteria-trash {
  width: 30px;
  text-align: center;
  cursor: pointer;
}
.new-criteria-card .criteria-input {
  width: calc(100% - 110px);
}
.gen-ai-text {
  background:
    linear-gradient(
      267deg,
      #C845AB 15.14%,
      #E24E7F 52.19%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.ai-chip-container {
  margin-bottom: 15px;
  position: relative;
}
.ai-chip-container .ai-screening-chips {
  cursor: pointer;
  border: 1px solid transparent;
  background-color: #FEF8FA;
  border-radius: 8px;
  color: #484B59;
  padding: 10px;
  margin-right: 0px;
  margin-bottom: 10px;
  align-items: center;
  position: relative;
  height: 38px;
}
.ai-chip-container .ai-screening-chips .gedient-criteria {
  position: absolute;
  color: #484b59 !important;
  left: 10px;
  top: 9px;
}
.ai-chip-container .ai-screening-chips .gedient-criteria .fa-plus {
  color: #D74B92;
}
.ai-chip-container .ai-screening-chips:hover {
  border: 1px solid #E54F7A;
}
.create-project-section {
  background-color: #fff;
  padding: 0px 0px;
  width: 100%;
  height: auto;
  margin-top: 55px;
}
.create-project-section .filter-layout .fl-container .criteria-body {
  padding: 0 !important;
}
.disabled {
  background-color: #969696;
  pointer-events: none;
}
.hire-btn-primary {
  width: 180px;
}
.hire-btn-primary.dropdown-toggle::after {
  display: none;
}
.hire-btn-primary.disabled {
  background-color: #969696;
  border-color: #969696;
  pointer-events: none;
}
/*# sourceMappingURL=hiring-criteria.component-D543IKDW.css.map */
